export default "__VITE_ASSET__DUFjKWFA__$_?url__"